import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { doRequest } from '@r1-frontend/do-request/index';
import { getRegionsGroups } from '@r1-frontend/api-domru/api-content/v1/geography/get-regions';
import { IRegionsWithCitiesGroup } from '@r1-frontend/api-domru/api-content/v1/geography/get-regions/dto/ResponseDto';
import { setRegions } from '@r1-frontend/entities/Layout/CitySelectContainer/store/actionCreators';
import { TState } from '@r1-frontend/entities/Layout/CitySelectContainer/store/reducer';
import selectProviderId from '@r1-frontend/entities/stores/city/selectors/selectProviderId';

const fetchRegionsList = () => {
    return async(dispatch: ThunkDispatch<TState, void, AnyAction>, getState: () => TState): Promise<void> => {
        const state = getState();
        const providerId = selectProviderId(state);

        const resp = await doRequest.apiContent<IRegionsWithCitiesGroup>(
            getRegionsGroups(providerId, { sortBy: 'name', groupBy: 'firstChar' }),
        );

        if (resp.isSuccess) {
            dispatch(setRegions(resp.payload));
        }
    };
};

export default fetchRegionsList;
